/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:contents}[_nghost-%COMP%]   .duration-sign[_ngcontent-%COMP%]{border-top:1.2px dashed var(--color-light-blue)}"];
export { styles as styles };
